import React from "react";
import { NavDivider as Divider } from "./style";

const NavDivider = () => <Divider flexItem orientation="vertical" />;
export default NavDivider;
